import type { HTMLProps } from 'react';
import { clsx } from 'clsx';
import styles from './error-message.module.scss';

interface ErrorMessageProps extends HTMLProps<HTMLDivElement> {
  id: string;
}

export function ErrorMessage({ className, children, ...rest }: ErrorMessageProps) {
  return (
    <div className={clsx(styles.errorMessage, className)} {...rest}>
      {typeof children === 'string' ? <span>{children}</span> : children}
    </div>
  );
}
